
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface PropertyDetailsFormProps {
  formData: {
    guests: number;
    bedrooms: number;
    bathrooms: number;
    area: number;
    latitude: number;
    longitude: number;
  };
  onInputChange: (field: string, value: any) => void;
}

const PropertyDetailsForm = ({ formData, onInputChange }: PropertyDetailsFormProps) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <Label htmlFor="guests">Huéspedes *</Label>
          <Input
            id="guests"
            type="number"
            min="1"
            value={formData.guests}
            onChange={(e) => onInputChange('guests', parseInt(e.target.value) || 1)}
            placeholder="Número de huéspedes"
            required
          />
        </div>
        <div>
          <Label htmlFor="bedrooms">Habitaciones</Label>
          <Input
            id="bedrooms"
            type="number"
            min="0"
            value={formData.bedrooms}
            onChange={(e) => onInputChange('bedrooms', parseInt(e.target.value) || 0)}
            placeholder="Número de habitaciones"
          />
        </div>
        <div>
          <Label htmlFor="bathrooms">Baños</Label>
          <Input
            id="bathrooms"
            type="number"
            min="0"
            step="0.5"
            value={formData.bathrooms}
            onChange={(e) => onInputChange('bathrooms', parseFloat(e.target.value) || 0)}
            placeholder="Número de baños"
          />
        </div>
      </div>

      <div>
        <Label htmlFor="area">Área (m²)</Label>
        <Input
          id="area"
          type="number"
          min="0"
          value={formData.area}
          onChange={(e) => onInputChange('area', parseInt(e.target.value) || 0)}
          placeholder="Área en metros cuadrados"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="latitude">Latitud</Label>
          <Input
            id="latitude"
            type="number"
            step="any"
            value={formData.latitude}
            onChange={(e) => onInputChange('latitude', parseFloat(e.target.value) || 0)}
            placeholder="Coordenada de latitud"
          />
        </div>
        <div>
          <Label htmlFor="longitude">Longitud</Label>
          <Input
            id="longitude"
            type="number"
            step="any"
            value={formData.longitude}
            onChange={(e) => onInputChange('longitude', parseFloat(e.target.value) || 0)}
            placeholder="Coordenada de longitud"
          />
        </div>
      </div>
    </div>
  );
};

export default PropertyDetailsForm;
